import { Observable } from "rxjs";
import * as _ from "lodash";
import NetworkService from "../network/networkService";
import { AgTechQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import { IRandomizationAttributeResponse } from "../models/IRandomization.model";
import { URLConfig } from "../network/urlStore";

export const getRandomization = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<IRandomizationAttributeResponse> => {
  let url = URLConfig.getRandomizationTrialMasterURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IRandomizationAttributeResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching user data", error);
      }
    );
  });
};
